"use client";

import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { useEffect } from "react";
import { useMerchantShopsStore } from "./merchant-shops-store";

/** เรียกครั้งเดียวใน layout — โหลดร้านเมื่อ login, ล้างเมื่อ logout */
export function useMerchantShopsHydrate() {
  const { isAuthenticated } = useAuthState();
  const fetchShops = useMerchantShopsStore((s) => s.fetchShops);
  const clearShops = useMerchantShopsStore((s) => s.clearShops);

  useEffect(() => {
    if (isAuthenticated) fetchShops();
    else clearShops();
  }, [isAuthenticated, fetchShops, clearShops]);
}

/**
 * อ่าน state ร้านจาก store + derived ตาม shopId
 * ใช้ useMerchantShopsHydrate() ใน layout ก่อน เพื่อให้ store มีข้อมูล
 */
export function useMerchantShops(shopId?: string) {
  const shops = useMerchantShopsStore((s) => s.shops);
  const isLoading = useMerchantShopsStore((s) => s.isLoading);
  const error = useMerchantShopsStore((s) => s.error);
  const refetch = useMerchantShopsStore((s) => s.fetchShops);
  const getShop = useMerchantShopsStore((s) => s.getShop);
  const getPermissions = useMerchantShopsStore((s) => s.getPermissions);

  const currentShop = shopId ? getShop(shopId) : undefined;
  const currentPermissions = currentShop?.permissions ?? [];
  const roleName = currentShop?.roleName ?? null;

  return {
    shops,
    isLoading,
    error,
    refetch,
    getShop,
    getPermissions,
    currentShop,
    currentPermissions,
    roleName,
  };
}
